import styled from 'styled-components';
import {dFlex, dFlexColumn, dFlexColumnAlineEnd, dFlexCenter, dFlexEnd} from '../../../../globalVariables/GlobalFlex';
import {agentTextFieldBase} from '../aiAgentTextField/AiAgentTextField.css';

export const container = styled.div`
    ${dFlexColumnAlineEnd}
    align-self: flex-end;
    gap: var(--space-xs);
    width: 100%;
`;

export const imageAttachment = styled.img`
    width: 200px;
    max-width: 100%;
    height: 140px;
    object-fit: contain;
    border-radius: var(--border-radius-border-radius-md, 8px);
`;

export const fileAttachment = styled.div`
    ${dFlexCenter}
    gap: var(--space-sm);
    width: 214px;
    max-width: 100%;
    height: 48px;
    padding: var(--space-xs) var(--space-sm);
    border: 1px solid var(--color-border-subtle);
    border-radius: var(--border-radius-border-radius-md, 8px);
    background: var(--color-bg-surface-default);
    box-sizing: border-box;
`;

export const fileName = styled.span`
    flex: 1;
    min-width: 0;
    font-size: var(--font-size-caption);
    line-height: 16px;
    color: var(--color-text-default);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: start;
`;

export const messageRow = styled.div<{$isEditing?: boolean}>`
    position: relative;
    width: 100%;
    ${dFlexEnd}
    gap: var(--space-sm);
`;

export const textBubble = styled.div`
    padding: var(--space-sm) var(--space-lg);
    border-radius: var(--border-radius-border-radius-2xl);
    background: var(--color-bg-surface-default);
    color: var(--color-text-default);
    font-size: var(--font-size-body);
    line-height: 1.4;
    white-space: pre-line;
    width: max-content;
    max-width: 100%;
`;

export const editButtonWrap = styled.div`
    opacity: 0;
    transition: opacity 0.15s ease;
    ${container}:hover &,
    &:focus-within {
        opacity: 1;
    }

    @media (hover: none) {
        opacity: 1;
        margin-inline-start: var(--space-xs);
    }
`;

export const editingBubble = styled.div`
    width: 100%;
    max-width: 100%;
    padding: var(--space-lg);
    border-radius: var(--border-radius-border-radius-lg, 12px);
    background: var(--color-bg-surface-default);
    ${dFlexColumn}
    gap: var(--space-md);
    box-sizing: border-box;
`;

export const editField = styled.textarea`
    ${agentTextFieldBase}
    padding: 0;
    line-height: 1.4;
    overflow: hidden;
`;

export const editDivider = styled.hr`
    width: 100%;
    margin: 0;
    border: none;
    border-top: 1px solid var(--color-border-subtle);
`;

export const editActions = styled.div`
    ${dFlex}
    gap: var(--space-sm);

    button {
        flex: 1 1 0;
    }
`;
